import React, { useEffect, useRef } from 'react';

import { UpdatePhotoEvents } from '../events/event-declarations';
import { builderDispatch } from '../../../_utils/ui';

const DuplicatesWarningModal = () => {
  const modalRef = useRef(null);
  const reviewButtonActionRef = useRef(null);

  const open = () => {
    if (modalRef.current) {
      $(modalRef.current).modal('show');
    }
  };

  useEffect(() => {
    const builderDispatchToken = builderDispatch.register((payload) => {
      if (
        payload.type === UpdatePhotoEvents.SHOW_DUPLICATE_PHOTO_WARNING_MODAL
      ) {
        reviewButtonActionRef.current = payload.onReviewButtonAction;
        open();
      }
    });

    if (modalRef.current) {
      $(modalRef.current).modal({
        show: false,
      });
    }

    return () => {
      builderDispatch.unregister(builderDispatchToken);
    };
  }, []);

  const handleReviewClick = () => {
    if (reviewButtonActionRef.current) {
      reviewButtonActionRef.current();
    }
  };

  return (
    <div className="modal fade" ref={modalRef}>
      <div className="modal-dialog vertically-centered-modal">
        <div className="modal-content">
          <div className="modal-heading">
            <h4 className="modal-title w-100 text-center">
              Duplicate Photos Uploaded
            </h4>
            <button className="close" data-dismiss="modal" aria-label="Close" />
          </div>
          <div className="modal-body text-center mt-2">
            <p>
              We’ve detected that there have been multiple copies of the same
              image(s) uploaded.
            </p>
          </div>
          <div className="modal-footer justify-content-center">
            <div className="row w-100">
              <div className="col">
                <button
                  className="btn btn-outline-info rounded-pill btn-block"
                  data-dismiss="modal">
                  Continue
                </button>
              </div>
              <div className="col">
                <button
                  className="btn btn-primary rounded-pill btn-block"
                  data-dismiss="modal"
                  onClick={handleReviewClick}>
                  Review Duplicates
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { DuplicatesWarningModal };
